import React, { Fragment } from 'react';
import { Button, Grid } from '@material-ui/core';
import join from 'url-join';
import ImpressionViewer from '../PatientInfo/ImpressionViewer';
import { useLang } from '../../util/lang';
import Moment from 'moment/moment';
import Zoom from 'react-medium-image-zoom';
import { downloadImages } from '../../util/function';

//@ts-ignore
import { ApiServerUrl } from '../../../src/config.json';

//Purpose: case_file and case_impression
//TODO: generic component for mapping different kinds of case_table value
export const CaseLogInfo = ({
    dataArray,
    idKey,
    caseKey,
    idState,
    caseActivityLogIdState,
    showCaseFile = true,
    showCaseImpression = true,
}) => {
    const get = useLang();

    return (
        <>
            {dataArray.length != 0 &&
                dataArray.map((item, index) => {
                    let retainer = item[caseKey];
                    let caseFile = retainer.case_file;
                    let caseImpression = retainer.case_impression;

                    const photos = Object.entries(caseFile).filter(
                        ([key]) => key.startsWith('photo') && caseFile[key] !== null
                    );

                    if (retainer[idKey] === idState && caseActivityLogIdState === item.case_activity_log_id)
                        return (
                            <Fragment key={index}>
                                {showCaseFile && caseFile && (
                                    <>
                                        <div style={{ display: 'block', width: '100%' }}>
                                            <p style={{ display: 'inline', marginRight: '15px' }}>
                                                <strong>{get('@PatientInfo.modals.uploadedAt')}</strong> :
                                                {Moment(item.created_date).format('YYYY-MM-DD HH:mm')}
                                            </p>
                                            <hr />
                                        </div>
                                        <Button onClick={() => downloadImages(caseFile, 'photo')} variant="outlined">
                                            {get('@PatientInfo.modals.download')}
                                        </Button>
                                        <Grid container>
                                            {photos.map(([key, value]) => (
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={6}
                                                    md={4}
                                                    key={key}
                                                    style={{ padding: 8, textAlign: 'center' }}
                                                >
                                                    <Zoom zoomMargin={48}>
                                                        <img
                                                            src={join(ApiServerUrl, value)}
                                                            style={{
                                                                maxHeight: 300,
                                                                width: 'auto',
                                                                marginLeft: 'auto',
                                                                marginRight: 'auto',
                                                                maxWidth: '100%',
                                                            }}
                                                        />
                                                    </Zoom>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </>
                                )}

                                {showCaseImpression && caseImpression && (
                                    <>
                                        <div style={{ display: 'block', width: '100%' }}>
                                            <p style={{ display: 'inline', marginRight: '15px' }}>
                                                <strong>{get('@PatientInfo.modals.uploadedAt')}</strong> :
                                                {Moment(item.created_date).format('YYYY-MM-DD HH:mm')}
                                            </p>
                                            <hr />
                                        </div>
                                        <Grid item xs={12} sm={12} md={12} style={{ padding: 8, textAlign: 'left' }}>
                                            <ImpressionViewer caseImpression={caseImpression} />
                                        </Grid>
                                    </>
                                )}
                            </Fragment>
                        );
                })}
        </>
    );
};
